<!--use this as template for new modals-->
<div
  class="wrapper"
  [class.large]="size === 'large'"
>
  <div class="modal-header">
    <div class="modal-header-top">
      <h2 class="title">
        {{ title }}
      </h2>
      <div class="modal-header-btns">
        @if (isNeedFullScreenBtn) {
          <button
            mat-mini-fab
            class="btn-screen"
            (click)="handleFullScreen()"
          >
            <mat-icon>{{ getFullScreenIcon() }}</mat-icon>
          </button>
        }

        <button
          mat-mini-fab
          class="close-btn"
          (click)="closeDialog('cancel')"
        >
          <mat-icon class="close-btn-icon">close</mat-icon>
        </button>
      </div>
    </div>
    @if (showStateToggle) {
      <div class="state-toggle">
        <mat-slide-toggle
          tabindex="-1"
          [(ngModel)]="isEditModeActive"
          (change)="handleStateToggleChange($event.checked)"
        ></mat-slide-toggle>
        <div class="label">
          Режим редактирования
        </div>
      </div>
    }
  </div>
  <div class="separator"></div>
  <main>
    <ng-content></ng-content>
  </main>
</div>
